import axios from '@/core/http'

const fetchRecordings = (page = 1, { query, status }) => {
  return axios
    .get('recordings/recordings/', { params: { page, query, status } })
    .then(res => res.data)
}

const fetchRecordingsStatuses = () => {
  return axios.get('recordings/recordings/statuses/').then(res => res.data)
}

export { fetchRecordings, fetchRecordingsStatuses }
